import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Home from "./pages/Home";
import SMEPlansPage from "./components/SMEPlansPage";
import SurveillancePage from "./components/SurveillancePage";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import AdminPricingManager from "./components/AdminPricingManager";
import ISPCustomerLogin from "./components/ISPCustomerLogin";
import ISPCustomerDashboard from "./components/ISPCustomerDashboard";
import ISPUserManagement from "./components/ISPUserManagement";
import ISPAddCustomer from "./components/ISPAddCustomer";
import ISPEditCustomer from "./components/ISPEditCustomer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sme-plans" element={<SMEPlansPage />} />
          <Route path="/surveillance" element={<SurveillancePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/pricing" element={<AdminPricingManager />} />
          <Route path="/customer/login" element={<ISPCustomerLogin />} />
          <Route path="/customer/dashboard" element={<ISPCustomerDashboard />} />
          <Route path="/isp/users" element={<ISPUserManagement />} />
          <Route path="/isp/add-customer" element={<ISPAddCustomer />} />
          <Route path="/isp/edit-customer/:customerId" element={<ISPEditCustomer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
